<template>
  <el-dialog
    class="schools-modal"
    :visible.sync="visible"
    width="600px"
    :show-close="false"
    :append-to-body="true"
  >
    <div slot="title" class="coustomHeader">
      <span>学校切换</span><i class="el-icon-close" @click="closeDialog"></i>
    </div>
    <el-form
      :inline="true"
      :model="searchForm"
      size="small"
      style="height: 44px"
    >
      <el-form-item>
        <el-select
          v-model="searchForm.school_type"
          placeholder="全部学校"
          @change="onSearch"
          clearable
          size="small"
        >
          <el-option label="校考" :value="1"></el-option>
          <el-option label="联考" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.search"
          placeholder="请输入学校ID或学校名称"
          size="small"
          @change="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="list">
      <div
        @click="changeAccount(item)"
        v-for="(item, index) in schools"
        :key="index"
        :data-unit="item.school_type"
        :class="[
          item.id == user.schoolId ? 'checked' : '',
          'item',
        ]"
      >
        <span>{{ item.schoolName }} ({{ item.id }})</span
        ><i class="el-icon-check float-right"></i>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import AcCardApi from "@/services/acCard";
// import {loadRoutes} from '@/utils/routerUtil'
import { mapMutations } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    user: {
      type: Object
    },
  },
  data() {
    return {
      searchForm: {
        school_type: '',
        search: '',
      },
      visible: false,
      schools: [],
    }
  },
  methods: {
    ...mapMutations("account", ["setUser", "setToken"]),
    open() {
      this.init()
    },
    onSearch() {
      let datas = _.cloneDeep(this.AllSchools)
      if (this.searchForm.school_type != '') {
        datas = datas.filter(
          (ik) => ik.school_type == this.searchForm.school_type
        )
      }
      if (this.searchForm.search != '') {
        datas = datas.filter(
          (ik) =>
            ik.id == this.searchForm.search ||
            ik.schoolName.indexOf(this.searchForm.search) > -1
        )
      }
      this.schools = datas
    },
    changeAccount(item) {
      
      if (item.id != this.user.schoolId) {
        // 更新token等信息
        AcCardApi.changeSchool({
          schoolId: item.id,
        }).then((response) => {
          
          let { data, errmsg, errno } = response;
          console.log(response,errno)
          if (errno === 0) {
            this.visible = false
            let { token, user } = data

            this.setUser(user);
            this.setToken(token);
            location.reload()
          }  
          })
      }
    },
    init() {
      AcCardApi.accountSchools({}).then(
        (response) => {
          console.log(response)
          let data = response;
          if (data.errno == 0) {
            // this.gradeList = response.data.data || []
            let list = data.data || []
            this.AllSchools = _.cloneDeep(list)
            this.schools = list
            this.visible = true
          }
        }
      )
    },
    closeDialog() {
      this.visible = false
    },
    onSubmit() {
      console.log(1)
    },
  },
}
</script>

<style lang="scss" scoped>
.schools-modal .el-dialog__header {
  padding: 0px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.schools-modal .el-form-item {
  margin-bottom: 0px;
  padding-bottom: 0px;
  line-height: 40px;
}

.coustomHeader {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding: 5px 10px;
}

.schools-modal .el-dialog__body {
  padding: 10px 15px;
}

.schools-modal .el-dialog__headerbtn {
  position: relative;
  top: 0px;
  right: 0px;
}

.schools-modal .list {
  max-height: 300px;
  min-height: 90px;
  overflow-y: auto;
  width: 100%;
}

.schools-modal .list .item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 45px;
  border-top: 0.55px solid #eee;
  border-top-color: #eee;
  overflow: hidden;
}
.schools-modal .list .item:hover{
  background-color: #e2ebff;
}
.schools-modal .list .item:last-child {
  border-bottom: 0.55px solid #eee;
}

.schools-modal .list .item i {
  display: none;
}

.schools-modal .list .item:before {
  content: '联';
  position: absolute;
  top: -22px;
  left: -22px;
  display: inline-block;
  width: 34px;
  height: 44px;
  background: #1890ff;
  line-height: 63.8px;
  padding-left: 25.88235px;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

.schools-modal .list .item[data-unit='1']:before {
  content: '校';
  background: #36c67d;
}

.schools-modal .list .item.checked {
  color: #1890ff;
}

.schools-modal .list .item.checked i {
  display: inline-block;
}
.el-dialog {
  z-index: 9999;
}
</style>
